<template>
    <div>
        <div class="row">
            <h5 class="font-weight-bold">{{$lang('Udostępniono dla bibliotek:')}}</h5>
        </div>
        <div class="row">
            <multiselect
                :searchable=true :close-on-select=false
                id="libraries" v-model="chosenLibraries" :options="chosenLibraries"
                :multiple="true"
                :custom-label="libraryName"
                track-by="id"
                :disabled="true"
                :placeholder="$lang('Wybierz biblioteki')"
                :selectLabel="$lang('Wybierz bibliotekę')"
                :selectedLabel="$lang('Wybrana biblioteka')"
                :deselectLabel="$lang('Usuń bibliotekę')"
            ></multiselect>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "selected-libraries-section",
    components: {Multiselect},
    props: {
        libraries: Array,
    },
    data() {
        return {
            chosenLibraries: this.libraries,
        }
    },
    methods: {
        libraryName({name}) {
            return name;
        },
    }
}
</script>

<style scoped>

</style>
